import {Box, Collapse, Drawer, Link, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar} from "@mui/material";
import React, {useEffect} from "react";
import {gecsevarConfig} from "../pages/MainPage";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import {ArticleListPath, ContentPath} from "./Container";
import {DrawerMenuModel} from "../models/DrawerMenuModel";

type MenuItemProps = {
    item: DrawerMenuModel
    selectionId: string
    setSelectionId: (id: string) => void
    setDrawerState: (state: boolean) => void
    collapseOpen: Map<string, boolean>
    setCollapseOpen: (state: Map<string, boolean>) => void
}

function MenuItem(props: MenuItemProps) {

    const [open, setOpen] = React.useState(false)

    useEffect(() => {
        setOpen(props.collapseOpen.get(props.item.id)!!)
    }, []);

    if (props.item.level === 'collapse') {
        return <>
            <Link key={props.item.id} style={{textDecoration: 'none'}} onClick={() => {
                const temp = props.collapseOpen
                const val = temp.get(props.item.id) === undefined ? false : temp.get(props.item.id)!
                temp.set(props.item.id, !val)
                setOpen(!val)
                props.setCollapseOpen(temp)
            }}>
                <ListItem disablePadding key={props.item.id}>
                    <ListItemButton selected={props.selectionId === props.item.id} sx={{pl: 0,}}>
                        <ListItemIcon>{}</ListItemIcon>
                        <ListItemText>{props.item.label}</ListItemText>
                        {open ? <ExpandLess/> : <ExpandMore/>}
                    </ListItemButton>
                </ListItem>
            </Link>
            <Collapse key={"collapse" + props.item.id} in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {gecsevarConfig?.getSubMenuFor(props.item.id).map((value, index) => (
                        <MenuListItem key={index} item={value} selectionId={props.selectionId} isSubmenu={true}
                                      setSelectionId={props.setSelectionId} setDrawerState={props.setDrawerState}
                        />
                    ))}
                </List>
            </Collapse>
        </>
    } else {
        return (
            <MenuListItem key={props.item.id} item={props.item} selectionId={props.selectionId} isSubmenu={false}
                          setSelectionId={props.setSelectionId} setDrawerState={props.setDrawerState}
            />
        )
    }
}

type MenuListItemProps = {
    item: DrawerMenuModel
    selectionId: string
    isSubmenu: boolean
    setSelectionId: (id: string) => void
    setDrawerState: (state: boolean) => void
}

function MenuListItem(props: MenuListItemProps) {

    const navigate = useNavigate()

    return (
        <Link key={props.item.id} style={{textDecoration: 'none'}} onClick={() => {
            if (props.item.articlePath?.length !== 0) {
                // navigate to internal page - path
                navigate(ContentPath + props.item.articlePath)
            } else if (typeof props.item.articleId === "number") {
                // navigate to internal page - ID
                navigate(ContentPath + props.item.articleId)
            }
            if (typeof props.item.articleCategoryId === "number") {
                // navigate to /{path}/{id} HTML page
                navigate(ArticleListPath + props.item.articleCategoryName)
            }
            props.setSelectionId(props.item.id)
            props.setDrawerState(false)
        }}>
            <ListItem disablePadding key={props.item.id} sx={{}}>
                <ListItemButton selected={props.selectionId === props.item.id} sx={{pl: 0,}}>
                    <ListItemIcon>{}</ListItemIcon>
                    <ListItemText sx={{marginLeft: props.isSubmenu ? 2 : 0}}>{props.item.label}</ListItemText>
                </ListItemButton>
            </ListItem>
        </Link>
    )
}

type DrawerMenuProps = {
    drawerState: boolean
    selectionId: string
    setDrawerState: (value: boolean) => void
    setSelectionId: (value: string) => void
}

export function DrawerMenu(props: DrawerMenuProps) {

    const [collapseStateMap, setCollapseStateMap] = React.useState(new Map<string, boolean>())

    return <Drawer
        anchor={'right'}
        open={props.drawerState}
        onClose={(_: React.SyntheticEvent<{}, Event>) => {
            props.setDrawerState(false)
        }}
        sx={{flexShrink: 1}}
    >
        <Toolbar/>
        <Box sx={{
            color: 'white',
            background: gecsevarConfig.getMenuBackground(),
            height: '100%'
        }}>
            <List disablePadding>
                <ListItem sx={{py: 2, px: 3}}>
                    <ListItemText>{gecsevarConfig.getMenuTitle()}</ListItemText>
                </ListItem>
                {gecsevarConfig?.getMenuNavigation().map((value, _) => (
                    <MenuItem key={value.id} item={value} selectionId={props.selectionId} setSelectionId={props.setSelectionId}
                              setDrawerState={props.setDrawerState}
                              collapseOpen={collapseStateMap}
                              setCollapseOpen={setCollapseStateMap}
                    />
                ))}
            </List>
        </Box>
    </Drawer>
}